export async function persistEvalDecision(args: {
  save: () => Promise<void>
  markSaved: () => boolean
  refresh: () => Promise<void>
  advance: () => Promise<void>
  onRefreshError: () => void
}): Promise<void> {
  await args.save()
  const isCurrent = args.markSaved()
  void Promise.resolve().then(args.refresh).catch(args.onRefreshError)
  if (isCurrent) await args.advance()
}

export function createExclusiveEvalAction(onBusy: (busy: boolean) => void) {
  let pending: Promise<void> | undefined
  return (action: () => Promise<void>): Promise<void> => {
    if (pending) return pending
    onBusy(true)
    pending = Promise.resolve()
      .then(action)
      .finally(() => {
        pending = undefined
        onBusy(false)
      })
    return pending
  }
}
